import * as React from "react"
import Svg, {
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath
} from "react-native-svg"

const TargetMissedIcon = (props) => {
  return (
    <Svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_3047_981)">
        <Path
          d="M20 8.515a.644.644 0 00.385-.826L18.4 2.238l1.08.704a.645.645 0 10.705-1.08L17.487.102a.734.734 0 00-.573-.066.68.68 0 00-.396.418l-.936 3.084a.645.645 0 001.234.374l.374-1.233 1.984 5.45c.12.33.486.509.826.386zM8.379 4.55a6.453 6.453 0 00-6.445 6.446 6.453 6.453 0 006.445 6.445 6.453 6.453 0 006.445-6.445A6.453 6.453 0 008.38 4.55zm11.687 5.801a.644.644 0 00-.644.645v3.867a.644.644 0 101.289 0v-3.867a.644.644 0 00-.645-.645z"
          fill="url(#paint0_linear_3047_981)"
        />
        <Path
          d="M8.379 2.617C3.759 2.617 0 6.377 0 10.997c0 4.62 3.759 8.378 8.379 8.378 4.62 0 8.379-3.759 8.379-8.379 0-4.62-3.76-8.379-8.38-8.379zm0 14.18a5.807 5.807 0 01-5.8-5.8c0-3.2 2.601-5.802 5.8-5.802s5.8 2.602 5.8 5.801c0 3.199-2.601 5.8-5.8 5.8zm0-9.024a3.226 3.226 0 00-3.223 3.223A3.226 3.226 0 008.38 14.22a3.226 3.226 0 003.223-3.223 3.226 3.226 0 00-3.223-3.223zm0 3.868a.645.645 0 110-1.29.645.645 0 010 1.29zm13.432 4.056l-1.289-1.29a.644.644 0 00-.911 0l-1.29 1.29a.644.644 0 00-.188.455v5.2a.645.645 0 001.1.455l.833-.833.834.833a.644.644 0 001.1-.455v-5.2a.644.644 0 00-.189-.455z"
          fill="url(#paint1_linear_3047_981)"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_3047_981"
          x1={11.3223}
          y1={17.4419}
          x2={11.3223}
          y2={0.00390001}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FF9AAB" />
          <Stop offset={1} stopColor="#FFDBE0" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_3047_981"
          x1={11}
          y1={21.9967}
          x2={11}
          y2={2.61719}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FD3A84" />
          <Stop offset={1} stopColor="#FFA68D" />
        </LinearGradient>
        <ClipPath id="clip0_3047_981">
          <Path fill="#fff" d="M0 0H22V22H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default TargetMissedIcon
